<template>
  <v-dialog :value="value" persistent content-class="no-scroll-dialog">
    <v-card class="py-4">
      <v-card-text class="d-flex flex-column">
        <v-icon size="64px" color="yellow darken-2">mdi-alert-circle-outline</v-icon>

        <div class="mt-4 text-center" style="font-size: 14px; font-weight: bold;">
          Oops something went wrong.
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" width="60%" @click="close">Try Again</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name:  'WizardOverlay',

  props: ['title', 'value'],

  methods: {
    close() {
      this.$emit('input', false)
      this.$emit('close')
    },
  },
}

</script>

<style>
  .no-scroll-dialog {
    overflow-y: clip;
  }
</style>